import { default as PropertySearchPage } from '../index';
import { getServerSideProps } from '../index';

export { getServerSideProps };
export default PropertySearchPage;
